import './Results.css'
import { useEffect, useState, useMemo } from 'react'
import {
  Panel,
  Title,
} from '@ui5/webcomponents-react'
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table'
import { Link, useLocation } from 'react-router-dom'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import axios from "axios";
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTableStyles } from '../utils/tableStyles'
import { useTheme } from '../utils/ThemeContext'
import '../styles/MaterialTableStyles.css';
import { ScoreBadge } from '../components/ScoreBadge';

const WeeklyScores = () => {
  const { theme } = useTheme();
  const { panelBackgroundColor, wideTableConfig, muiTablePaperSx, muiTopToolbarSx, muiBottomToolbarSx } = useTableStyles();
  //retrieve any search Params
  //const reqDatePlayed = '2023-09-11'
  const location  = useLocation();
  const isMobile = useMediaQuery('(max-width:768px)');
  const [showScrollHint, setShowScrollHint] = useState(true);
  const handleTableScroll = (e) => {
    const el = e.currentTarget;
    setShowScrollHint(el.scrollLeft + el.clientWidth < el.scrollWidth - 5);
  };
  const id = new URLSearchParams(location.search).get('datePlayed')

  //results from backend.  useState in order to share the data across functions/components
  const [standingData, updateStandingData] = useState([])
  const [statsData, updateStatsData] = useState([])
  const [loading, setLoading] = useState(true)
  const [pars, setPars] = useState([])

  //get the needed data for the standings and stats
  useEffect(() => {
    setLoading(true)
    getData(id)
  }, [id])

  async function getData(id) {
    axios.all([
      axios.get("api/public/getWeeklyStats.php?rptDate=" + id),
      axios.get("api/reporting/rptScores.php?rptDate=" + id),
    ])
    .then(axios.spread((obj1, obj2) => {
      updateStatsData(obj1.data.stats)
      const records = obj2.data.records
      updateStandingData(records)
      // fetch pars for the course used this week by matching on course name
      if (records && records.length > 0) {
        const courseName = records[0].course
        axios.get("api/courses/read.php")
          .then((res) => {
            const match = (res.data.records || []).find(c => c.courseName === courseName)
            if (match) {
              setPars([match.par_1, match.par_2, match.par_3, match.par_4, match.par_5, match.par_6, match.par_7, match.par_8, match.par_9].map(Number))
            }
          })
          .catch((err) => console.error("Error fetching course pars:", err))
      }
    })).catch((error) =>{
      console.error("Error fetching data: ", error)
    }).finally(() => {
      setLoading(false)
    })
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const columns = useMemo(
    () => [
              {
                header: 'Player',
                accessorKey: 'player',
                size: 120,
                minSize: 120,
                maxSize: 120,
                muiTableHeadCellProps: { sx: { padding: '4px 8px', boxSizing: 'border-box', backgroundColor: theme.primary, color: '#fff', fontSize: '12px', '& .MuiIconButton-root': { color: '#fff !important' }, '& svg': { color: '#fff !important', fill: '#fff !important' } } },
                muiTableBodyCellProps: { sx: { padding: '4px 8px', boxSizing: 'border-box', fontSize: '12px' } },
                Cell: ({renderedCellValue}) => (
                  <span style={{ fontWeight: 'bold', color: theme.primary }}>{renderedCellValue}</span>
                )
              },
              {
                header: 'Points',
                accessorKey: 'points',
                size: 90
              },
              {
                header: 'hcp',
                accessorKey: 'handicap',
                size: 80
              },
              {
                header: 'N1',
                accessorKey: 'net1',
                size: 70,
                Cell: ({ cell }) => <ScoreBadge score={cell.getValue()} par={pars[0]} zeroAsEagle />,
              },
              {
                header: 'N2',
                accessorKey: 'net2',
                size: 70,
                Cell: ({ cell }) => <ScoreBadge score={cell.getValue()} par={pars[1]} zeroAsEagle />,
              },
              {
                header: 'N3',
                accessorKey: 'net3',
                size: 70,
                Cell: ({ cell }) => <ScoreBadge score={cell.getValue()} par={pars[2]} zeroAsEagle />,
              },
              {
                header: 'N4',
                accessorKey: 'net4',
                size: 70,
                Cell: ({ cell }) => <ScoreBadge score={cell.getValue()} par={pars[3]} zeroAsEagle />,
              },
              {
                header: 'N5',
                accessorKey: 'net5',
                size: 70,
                Cell: ({ cell }) => <ScoreBadge score={cell.getValue()} par={pars[4]} zeroAsEagle />,
              },
              {
                header: 'N6',
                accessorKey: 'net6',
                size: 70,
                Cell: ({ cell }) => <ScoreBadge score={cell.getValue()} par={pars[5]} zeroAsEagle />,
              },
              {
                header: 'N7',
                accessorKey: 'net7',
                size: 70,
                Cell: ({ cell }) => <ScoreBadge score={cell.getValue()} par={pars[6]} zeroAsEagle />,
              },
              {
                header: 'N8',
                accessorKey: 'net8',
                size: 70,
                Cell: ({ cell }) => <ScoreBadge score={cell.getValue()} par={pars[7]} zeroAsEagle />,
              },
              {
                header: 'N9',
                accessorKey: 'net9',
                size: 70,
                Cell: ({ cell }) => <ScoreBadge score={cell.getValue()} par={pars[8]} zeroAsEagle />,
              },
              {
                header: 'Net',
                accessorKey: 'netTotal',
                size: 70,
                muiTableBodyCellProps: { sx: { backgroundColor: theme.panelBgAlt } },
              },
              {
                header: 'G1',
                accessorKey: 'gross1',
                size: 70,
                Cell: ({ cell }) => <ScoreBadge score={cell.getValue()} par={pars[0]} zeroAsEagle />,
              },
              {
                header: 'G2',
                accessorKey: 'gross2',
                size: 70,
                Cell: ({ cell }) => <ScoreBadge score={cell.getValue()} par={pars[1]} zeroAsEagle />,
              },
              {
                header: 'G3',
                accessorKey: 'gross3',
                size: 70,
                Cell: ({ cell }) => <ScoreBadge score={cell.getValue()} par={pars[2]} zeroAsEagle />,
              },
              {
                header: 'G4',
                accessorKey: 'gross4',
                size: 70,
                Cell: ({ cell }) => <ScoreBadge score={cell.getValue()} par={pars[3]} zeroAsEagle />,
              },
              {
                header: 'G5',
                accessorKey: 'gross5',
                size: 70,
                Cell: ({ cell }) => <ScoreBadge score={cell.getValue()} par={pars[4]} zeroAsEagle />,
              },
              {
                header: 'G6',
                accessorKey: 'gross6',
                size: 70,
                Cell: ({ cell }) => <ScoreBadge score={cell.getValue()} par={pars[5]} zeroAsEagle />,
              },
              {
                header: 'G7',
                accessorKey: 'gross7',
                size: 70,
                Cell: ({ cell }) => <ScoreBadge score={cell.getValue()} par={pars[6]} zeroAsEagle />,
              },
              {
                header: 'G8',
                accessorKey: 'gross8',
                size: 70,
                Cell: ({ cell }) => <ScoreBadge score={cell.getValue()} par={pars[7]} zeroAsEagle />,
              },
              {
                header: 'G9',
                accessorKey: 'gross9',
                size: 70,
                Cell: ({ cell }) => <ScoreBadge score={cell.getValue()} par={pars[8]} zeroAsEagle />,
              },
              {
                header: 'Gross',
                accessorKey: 'grossTotal',
                size: 90,
                muiTableBodyCellProps: { sx: { backgroundColor: theme.panelBgAlt } },
              },
            ],
            [pars, theme],
    );
  
  //pull out the stats values from the only element in the statsData Array
  const numPlayers = statsData.map((stats) => {
    return [
        stats.numPlayers
    ]

  })

  const avgNet = statsData.map((stats) => {
    return [
        stats.avgNet
    ]

  })

  const avgGross = statsData.map((stats) => {
    return [
        stats.avgGross
    ]

  })

  const course = statsData.map((stats) => {
    return [
        stats.course
    ]

  })

  const datePlayed = statsData.map((stats) => {
    return [
        stats.datePlayed
    ]

  })

 const table = useMaterialReactTable({
    columns,
    data: standingData,
    ...wideTableConfig,
    enableStickyHeader: true,
    enableFilters: true,
    enableColumnFilters: false,
    enableHiding: false,
    enableColumnPinning: true,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableColumnActions: false,
    muiTableContainerProps: { sx: { overflowX: 'auto', maxWidth: '100%', maxHeight: '75vh' }, onScroll: handleTableScroll },
    muiTablePaperProps: { sx: { ...muiTablePaperSx, width: isMobile ? '100%' : '60%', marginLeft: 'auto', marginRight: 'auto' } },
    muiTopToolbarProps: { sx: muiTopToolbarSx },
    muiBottomToolbarProps: { sx: muiBottomToolbarSx },
    initialState: { density: 'compact',  pagination: {pageIndex: 0, pageSize: 10}, columnPinning: { left: ['player'] } },
    layoutMode: 'semantic',
    state: {isLoading: loading},
  });

 return(
  <>
    <Panel fixed stickyHeader style={{backgroundColor: panelBackgroundColor}} header={<><Link to="/results"><ArrowBackIcon style={{ verticalAlign: 'middle', color: theme.primary }} /></Link><span style={{paddingLeft: "10px"}}>{datePlayed} - {course}</span></>}>
      <Box pt={2} pb={3}>
      <Title style={{fontSize: "13px"}}>
        <Stack direction='row'>
        <Box pr={4}>
        <b>Members:</b> {numPlayers}
        </Box>
        <Box pr={4}>
        <b>Net Avg:</b> {avgNet}
        </Box>
        <Box>
        <b>Gross Avg:</b> {avgGross}
        </Box>

        </Stack>
      </Title>
      </Box>
      <div style={{ position: 'relative' }}>
        <MaterialReactTable table={table} />
        {isMobile && showScrollHint && (
          <div style={{
            position: 'absolute', top: 0, right: 0, bottom: 0, width: '48px',
            background: `linear-gradient(to right, transparent, ${theme.panelBgFade})`,
            pointerEvents: 'none', zIndex: 5,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <span style={{ fontSize: '1.2rem', color: theme.primary, opacity: 0.8 }}>›</span>
          </div>
        )}
      </div>
    </Panel>
  </>
  )
  }
  
  export default WeeklyScores; 